export enum DevFeatures {
  AutomationGenerate,
  DataInsights,
  Experimental,
  WorkOrder,
  WorkOsLogin,
}

export enum ProductFeatures {
  allocations = 'Allocations',
  billAutomation = 'Bill Automation',
  customDashboards = 'Custom Dashboards',
  energyCapSync = 'EnergyCAP Sync',
  energyStarManagement = 'ENERGY STAR Management',
  evCharging = 'EV Charging',
  reporting = 'Reporting',
  smartMeters = 'Smart Meters',
}
